<template>
    <section class="vx-row justify-center w-full py-6 md:py-12 lg:py-24 mb-24 mx-1">
		<div class="vx-col w-full md:w-full lg:w-5/6">
			<vx-card>
				<header class="vx-row justify-between">
					<div class="vx-col w-full md:w-1/2 mb-8 flex items-center">
						<router-link :to="`/home`">
							<feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
						</router-link>
						<strong class="block text-primary"><small>Menunggu Pembayaran</small></strong>
					</div>
					<div class="vx-col hidden md:flex md:w-1/2 flex justify-end">
						
					</div>
				</header>
				

				<div class="flex justify-center mb-12">
					<img src="/assets/images/topup/confirm.svg" alt="" class="md:w-1/4 w-1/6" />
				</div>
				<section class="vx-row justify-center mb-12" v-if="history.metode_pembayaran">
					<div class="vx-col lg:w-5/6 xl:w-2/3">
						<table class="w-full">
							<tr>
								<td class="text-left py-2"><strong class="text-dark">Qurban</strong></td>
								<td class="text-right py-2"><strong class="text-grey">{{ truncateString(qurban.name, 150) }}</strong></td>
							</tr>
							<tr>
								<td class="text-left py-2">
									<strong class="text-dark">Total Pembayaran</strong>
								</td>
								<td class="text-right py-2">
									<strong class="text-grey">Rp {{ formatRupiah(history.jumlah_bayar) }}</strong>
								</td>
							</tr>
						</table>
						<vs-divider class="my-4"></vs-divider>
						<!-- VA -->
						<div v-if="history.metode_pembayaran.category === 'bank_transfer'">
							<table class="w-full">
								<tr>
									<td class="text-left">
										<img v-if="history.file_url !== null" :src="history.file_url" alt="" class="w-16 md:w-24" />
									</td>
									<td class="text-center">
										<h6 class="mb-2">{{ history.metode_pembayaran.name }}</h6>
										<strong class="block">{{ history.no_pembayaran }}</strong>
										<small class="text-danger">Pembayaran Berakhir pada {{history.expired}}</small>
									</td>
									<td></td>
								</tr>
							</table>
						</div>
						<!-- / -->
						<!-- USING GOPAY -->
						<div  v-if="history.metode_pembayaran.code === 'gopay'">
							<header class="flex justify-center">
								<img v-if="history.qr_checkout_url !== null" :src="history.qr_checkout_url" alt="" class="w-full md:w-1/2 lg:w-1/4" />	
							</header>
							<vs-collapse>
							<vs-collapse-item>
								<div slot="header">
									<small>
										<strong>Petunjuk Bayar</strong>
									</small>
								</div>
								<div>
									<strong>
									Silahkan bayar <a :href="history.web_checkout_url" style="color: blue" target="_blank">disini</a>
									</strong>
								</div>
							</vs-collapse-item>

						</vs-collapse>
						</div>

					</div>
				</section>
				<section class="mb-6" v-else>
					<h3 class="text-center mb-2">
						<strong class="text-danger">Mohon maaf ada kesalahan saat pembayaran kamu</strong>
					</h3>
					<p class="text-center">Coba ulangi transaksinya</p>
				</section>
				<vs-button class="w-full rounded-lg" @click.prevent="toHome">
					<strong class="text-white">{{ history.metode_pembayaran ? 'Ok' : 'Pilih Metode Bayar' }}</strong>
				</vs-button>
			</vx-card>
		</div>
	</section>
</template>
<script>
    export default {
		data: () => ({
			qurban: {
				name: ''
			},
			history: {}
		}),
        computed: {
            transactionHistory() {
                return this.$store.state.qurban.transactionHistory;
            }
        },
        methods: {
            toHome() {
				const history = this.$store.state.qurban.transactionHistory;

				if(history && history.metode_pembayaran) {
					this.$store.dispatch('qurban/removeTransactionHistory');
					this.$router.push('/home');
				}
				else {
					this.$router.push(`/qurban/choose-payment/${ this.$route.params.slug_and_id }`);
				}
            },
			getDetail() {
				// get id from slug
				const arrSlug = this.$route.params.slug_and_id.split('-'),
						id = Buffer.from(arrSlug[ arrSlug.length - 1 ], 'base64').toString();

				// Check if exist in state
				this.$store.dispatch('qurban/getDetail', id)
				.then(qurban => this.qurban = qurban);
			}
        },
        created() {
			this.checkVerifyAccount();
			this.getDetail();

			Object.assign(this.history, this.transactionHistory);

			if(this.history && this.history.metode_pembayaran) {
				this.$store.dispatch('qurban/removeTransactionProduct');
				this.$store.dispatch('qurban/removeTransactionPayment');
	
				if(['ID_LINKAJA', 'ID_DANA'].includes(this.history.metode_pembayaran.code)) {
					if(this.history.web_checkout_url) {
						window.location.href = this.history.web_checkout_url;
					}
				}
				this.history.file_url = null;
				if(this.history.metode_pembayaran.file !== null) {
					this.history.file_url = process.env.VUE_APP_STORAGE + '/' + this.history.metode_pembayaran.file;
				}
			}

        }
    }
</script>